import React, { useState, useEffect, useContext, useMemo } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import _ from "lodash";
import UploadData from "./UploadData";
import ActionPlansContext from "context/ActionPlansContext";
import ActionContext from "context/ActionContext";
import UserService from "services/UserService";
import { getSite } from "services/ConfigServices";
import AddButton from "components/CustomButtons/AddButton";
import AddIcon from "@mui/icons-material/Add";
import AddEquipmentDialog from "./AddEquipmentDialog.js";
//import useActionTable from "../useActionTable.js";

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const UploadButton = styled.div`
  margin-left: 15px;
  &:hover {
    cursor: pointer;
  }
`;

export default function useActionTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanadmin = permis.includes("actionplan_admin");
  const [totalRows, setTotalRows] = useState(0);
  const [results, setResults] = useState();
  const [isRefetched, setIsRefetched] = useState(false);

  const appContext = useContext(ActionPlansContext);
  const { actionPlans } = appContext;
  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;

  const [structureData, setStructureData] = useState([]);

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const refreshTable = () => {
    setIsRefetched(!isRefetched);
  };

  useEffect(() => {
    console.log("Isrefetched render");
    getStructureData("equipments.equipmentlist");
  }, [isRefetched]);

  // useEffect(() => {
  //   console.log(action.parameters?.impact?.equipments);
  //   filteringData(action.parameters?.impact?.equipments);
  // }, [action.parameters?.impact?.equipments]);

  function filteringData(data) {
    const allowed = [
      "name",
      "uuid",
      "id",
      "surface",
      "thermicalresistance",
      "deperditionpart",
      "uwall",
      "isSelected",
    ];

    const filteredData = [];
    data.map((equipment) => {
      const filteredObj = _.pick(equipment, allowed);
      filteredData.push(filteredObj);
    });

    const newKeys = { uuid: "id" };

    const replacedUuidWithIdName = [];

    filteredData.map((equipment) => {
      const renamedObj = renameKeys(equipment, newKeys);
      replacedUuidWithIdName.push(renamedObj);
    });

    setStructureData(replacedUuidWithIdName);
  }

  const getStructureData = async (route) => {
    let data = [];
    let equipments = action.parameters?.impact?.equipments || [];

    let equipmentsIds = equipments.map((equipment) => {
      return equipment.uuid;
    });
    await axios
      .get(getSite(action.parameters.general.groups[0], route), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        data = res?.data?.detail?.equipments?.equipmentlist || [];
      });

    setStructureData([
      ...data.filter((obj) => !equipmentsIds.includes(obj.uuid)),
      ...equipments,
    ]);
  };

  function renameKeys(obj, newKeys) {
    const keyValues = Object.keys(obj).map((key) => {
      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  }

  const handleSimulate = (event) => {};

  const UploadComponent = ({ onUpload }) => (
    <>
      <UploadButton type="button" onClick={onUpload}>
        {/*<PublishIcon fontSize="medium" />
        <UploadText>Import</UploadText>*/}
        <UploadData
          type="button"
          onClick={onUpload}
          open={open}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          buttonTitle={"Nouvel équipement"}
          dialogTitle={"Ajout d'un équipement"}
          content={
            <AddEquipmentDialog
              closeModal={() => handleClose()}
              refetch={refreshTable}
              //deleteCounter={() => handleDeleteCounterChange()}
            />
          }
        />
      </UploadButton>
    </>
  );

  // ----------------------------------------------------------

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <>
        <TableName>Liste des equipements</TableName>

        {actionplanadmin && <UploadComponent key="UploadComponent" />}
      </>
    );
  }, [open]);

  // const headerComponentMemo = useMemo(() => {
  //   return (
  //     <>
  //       <TableName>Liste des equipements</TableName>
  //     </>
  //   );
  // }, []);

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  return {
    gridState: {
      defaultPageSize: 10,
      data: structureData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      //title: headerComponentMemo,
      subHeaderComponent: subHeaderComponentMemo,
    },
    refreshTable,
  };
}
